import { ref, computed } from 'vue';

const spacer = ref(0);

export function useFixedActionsSpacer() {
  const offset = computed(() => spacer.value + 'px');

  return { spacer, offset };
}
